// extracted by mini-css-extract-plugin
export var playButton = "Player-module--playButton--d0389";
export var playerContainer = "Player-module--playerContainer--e19bf";
export var playing = "Player-module--playing--18982";
export var videoOverlay = "Player-module--videoOverlay--13b88";